import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ContactsProfileComponent } from '../contacts-profile/contacts-profile.component';
import { ContactsService } from '../../../service/component_dependent/contacts/contacts.service';
import { ListComponent } from '../../shared/list/list.component';
import { Data } from '../../../model/data';
import { Contacts } from '../../../model/contacts';
import { ContactNumber } from '../../../model/contact-number';

@Component({
  selector: 'app-contacts-home',
  templateUrl: './contacts-home.component.html',
  styleUrls: ['./contacts-home.component.scss']
})
export class ContactsHomeComponent implements OnInit, AfterViewInit {

  @ViewChild(ContactsProfileComponent) appContactsProfile: ContactsProfileComponent;
  @ViewChild(ListComponent) appList: ListComponent;

  protected contacts: Data[];

  protected maxItemsPerPage: number = 18;
  protected total: number;
  protected page: number = 1;

  protected keyword: string;

  protected loading: boolean;

  constructor(private contactsService: ContactsService) {

  }

  ngOnInit() {
    this.initComponents();
  }

  ngAfterViewInit() {

  }

  protected openContactsProfileModal() {
    this.appContactsProfile.open();
  }

  protected initComponents() {
    this.getContactNumbers(this.maxItemsPerPage, this.keyword, this.page);
  }

  protected getContactNumbers(maxItemsPerPage, keyword, page) {
    this.maxItemsPerPage = maxItemsPerPage;
    this.keyword = keyword;
    this.page = page;

    this.loading = true;
    this.contactsService.getContactNumbers(maxItemsPerPage, keyword, page, null).subscribe(
      (dataContacts: any) => {
        this.reassignVariablesContacts(dataContacts.data);
        this.loading = false;
      },
      (errorContacts: any) => {
        this.loading = false;
      }
    );
  }

  protected onEdit(obj: any) {
    let id;

    id = obj.id;
    this.contactsService.getContactNumbers(null, null, null, id).subscribe(
      (dataContactNumber: any) => {
        let editContact;
        let editContactNumber;
        let data;

        editContact = new Contacts();
        editContactNumber = new ContactNumber();
        data = dataContactNumber.data.data;

        editContact.id = data.c_id;
        editContact.salutation = data.salutation;
        editContact.first_name = data.first_name;
        editContact.last_name = data.last_name;
        editContact.middle_name = data.middle_name;
        editContact.birthdate = data.birthdate;
        editContactNumber.id = data.cn_id;
        editContactNumber.contact_id = data.c_id;
        editContactNumber.number = data.number;
        editContactNumber.country_code = data.country_code;

        this.appContactsProfile.contact = editContact;
        this.appContactsProfile.contact_number = editContactNumber;
        this.appContactsProfile.edit();
      },
    )
  }

  private reassignVariablesContacts(elem: any) {

    var instance: Data
    var data = elem.data;

    this.contacts = new Array<Data>();
    this.total = elem.total;

    for (var i = 0; i < data.length; i++) {
      instance = new Data();
      instance.id = data[i].id;
      instance.date = data[i].created_at;
      instance.title = data[i].country_code + "" + data[i].number;
      instance.description = (this.getFormattedName(data[i].first_name) + " " + this.getFormattedName(data[i].last_name));

      this.contacts.push(instance);
    }
  }

  private getFormattedName(name: string) {
    return (name == null) ? "" : name;
  }

}
